import { html } from 'lit';
import { TimelineToolbarItem } from '../types/timeline-toolbar-item.interface';

/**
 * Toolbar item for resetting tasklist scroll position to today.
 *
 * Uses direct DOM access on ha-tasklist-view to call its scrollToToday()
 * method, which scrolls directly and persists the anchor via
 * appState.setTaskListScrollAnchor() (no command involved — see
 * HaTasklistView.scrollToToday()).
 *
 * @remarks
 * Intentional technical debt: document.querySelector('ha-tasklist-view') as any
 * is accepted per PRD-055 design decision. Will be resolved when HaTasklistView
 * is migrated to AbstractO2dTimelineView.
 */
export const tasklistResetToTodayToolbarItem: TimelineToolbarItem = {
    id: 'tasklist-reset-to-today',
    position: 'start',
    order: 5,
    render: () => {
        return html`
            <button type="button"
                    class="focus-today buttonform-marker secondary"
                    data-label="Fokus\nauf Heute"
                    @click=${() => {
                        const tasklistView = document.querySelector('ha-tasklist-view') as any;
                        tasklistView?.scrollToToday?.();
                    }}
            >
                <div class="hover-effect"></div>
            </button>
        `;
    },
};
